import { GetSourceDataTrialConfigurationByTrialCode, SourceDataConfigurationSingleResponse } from '@/api/dtos';
import { useGet, usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<SourceDataConfigurationSingleResponse, SourceDataConfigurationSingleResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<SourceDataConfigurationSingleResponse, SourceDataConfigurationSingleResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useTrialConfigurationByTrialCode = (trialCode?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new GetSourceDataTrialConfigurationByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useTrialConfigurationByTrialCode;